import React from "react";
interface props {
  className?: string;
}

function Icon3({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 42 43"
    >
      <circle cx="21" cy="21.059" r="20.5" stroke="#FF752C"></circle>
      <path
        fill="#FF752C"
        d="M22.023 25.104l1.877-1.442 1.877 1.442-.696-2.331 1.896-1.542h-2.33L23.9 18.95l-.746 2.28h-2.331l1.896 1.543-.696 2.331zM12 28V14h6.596l2 2H30v12H12zm1-1h16V17h-8.806l-2-2H13v12z"
      ></path>
    </svg>
  );
}

export default Icon3;
